import { EstateType } from '@/modules/estate/enums/EstateType';
import { BaseWorkflowRule } from '@/modules/workflow/models/BaseWorkflowRule';

export class WorkflowEstateRule extends BaseWorkflowRule {
  id?: number;

  estateType?: string;

  constructor(model: Partial<WorkflowEstateRule> = {}) {
    super(model);

    this.id = model.id;
    this.estateType = model.estateType;
  }

  get ruleId(): string | undefined {
    return this.estateType;
  }

  toString(): string {
    return EstateType.getByKey(this.estateType).value;
  }
}
